module.exports = __webpack_public_path__ + "static/media/org-admin.36efd425.jpg";